import { render, staticRenderFns } from "./GeneralMacroPopup.vue?vue&type=template&id=2833fbc4&scoped=true&"
import script from "./GeneralMacroPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralMacroPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMacroPopup.vue?vue&type=style&index=0&id=2833fbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833fbc4",
  null
  
)

export default component.exports